// extracted by mini-css-extract-plugin
export default {"review":"Review_review__Q5MZZ","icon":"Review_icon__w7Bie","person":"Review_person__myEpd","person_img":"Review_person_img__CUvDk"};